module.exports = __webpack_public_path__ + "media/cc-payment-guide.88a62209.mp4";